<template>
  <div style="background: #0d6fb8">
    <headerNav title="升级活动奖品" />
    <div>
        <div>
            <img style="width: 100%" src="../../../assets/images/cj01.jpg" />
        </div>
       <div class="drawcards">
      <van-divider :style="{ color: '#fff', borderColor: '#ffffff', padding: '0 16px' }">
        <h2>我的奖品</h2>
      </van-divider>
      <div
        class="drawcard"
        v-for="(item, index) in list"
        @click="opengift(item)"
        :key="index"
      >
        <div class="draw-content">
         
          <div
            class="drawcard-wz"
            v-for="item2 in item.upgradeActiveRecordDetails"
            :key="item2.id"
          >
           <div class="drawcard-pic" v-if="item2.product.productImageUrl">
                            <img :src="$baseurl+item2.product.productImageUrl" />
                        </div>
                        <div class="drawcard-wz" >
                            <div>{{item2.product.pName}}</div>
                            <div>x{{item2.num}}</div>
                            <!-- <div>{{item.drawTime}} 
                                <span style="float:right;font-size:12px">
                                    <span v-if="item.drawLotteryEnum==0&&!item.isUsed">点击领取</span>
                                    <span v-if="item.drawLotteryEnum==2">查看联系方式</span>
                                </span>
                             </div> -->
                        </div>
            <!-- <div>{{item.drawTime}} 
                                <span style="float:right;font-size:12px">
                                    <span v-if="item.drawLotteryEnum==0&&!item.isUsed">点击领取</span>
                                    <span v-if="item.drawLotteryEnum==2">查看联系方式</span>
                                </span>
                             </div> -->

          </div>
          <div class="nmheader">
              <span style="float:left">需支付: {{item.payment}}元物料费用</span>
              <span style="float:right" v-if="!item.isUse" >点击领取</span>
               <span style="float:right"  v-if="item.isUse">已领取</span>
          </div>
          <!-- <div class="drawcard-mm">
                            <span  v-if="item.drawLotteryEnum==0&&!item.isUsed">未领取</span>
                            <span  v-if="item.drawLotteryEnum==0&&item.isUsed">已领取</span>
                            <span  v-if="item.drawLotteryEnum==2">请联系上级代理索取</span>
                            <span  v-if="item.payment"> | 需支付{{item.payment}}元</span>
                        </div> -->
        </div>
      </div>
      <div v-if="list.length == 0" style="text-align: center; font-size: 14px">
        您目前没有奖品哦,赶紧参与抽奖活动吧
      </div>
    </div>
    </div>
    <!-- <img style="width: 100%" src="../../assets/images/fh001.jpg" /> -->
   

    <van-dialog
      v-model="nshow"
      title="领取"
      @confirm="gobuy()"
      show-cancel-button
      showConfirmButton
      confirmButtonText="领取"
    >
      <div style="color: #a8a8a8; padding: 10px">
        温馨提示：礼品的收货地址为您的默认地址，请确认地址是否准确。
        <span style="color: red" v-if="defaultaddress">
          当前礼品收件信息为：{{ defaultaddress.receiverName }}，{{
            defaultaddress.receiverMobile
          }}，{{
            defaultaddress.receiverState +
            defaultaddress.receiverCity +
            defaultaddress.receiverDistrict +
            defaultaddress.receiverAddress
          }}。（如不正确，请到收货地址管理变更默认地址后再领取）
        </span>
         <div v-if="curitem" style="text-align:center;border:1px solid #999;color:#666">
                    <div>奖品列表</div>
<div v-for="(item,index) in curitem.upgradeActiveRecordDetails" :key="index">
                    <div >{{item.product.pName}}</div>
                    <van-field
                        v-model="item.specname"
                        readonly
                        clickable
                        name="picker"
                        label="规格选择"
                        placeholder="点击选择规格"
                        @click="selectp(index)"
                        />
                </div>
                </div>
      </div>
    </van-dialog>

     <van-popup v-model="showPicker" position="bottom">
            <van-picker
                title="选择规格"
                show-toolbar
                :columns="columns"
                @confirm="onConfirm"
                @cancel="showPicker = false"
            />
        </van-popup>
  </div>
</template>
<script>
export default {
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      nshow: false,
      defaultaddress: undefined,
      curitem: undefined,
      parentinfo: undefined,
      fshow: false,
      curitemProductIndex:0,
      showPicker:false,
      columns:[],
    };
  },
  created() {
    this.querydefault();
    this.loadData();
  },
  methods: {
    querydefault() {
      // let id=localStorage.getItem('changeaddress') || 0;
      // localStorage.setItem('changeaddress','');
      this.ajax.post("/api/services/app/PhoneUser/QueryDefaultAddress?id=0").then((x) => {
        this.defaultaddress = x.result;
      });
    },
    gobuy() {
      this.defaultaddress.recordId = this.curitem.id;
      this.defaultaddress.products=[];
      this.curitem.upgradeActiveRecordDetails.map(x=>{
                    this.defaultaddress.products.push({
                        productId:x.productId,
                        specId:x.specid
                    })
                })
      this.ajax
        .post("/api/services/app/PhoneUpgradeActive/ConversionOrder", this.defaultaddress)
        .then((x) => {
          this.$toast("领取成功");
          this.nshow = false;
          this.loadData();
        })
        .catch((x) => {});
    },
    queryparentinfo() {
      this.ajax
        .post("/api/services/app/PhoneDrawLottery/QueryMySuperiorWxQrCode")
        .then((x) => {
          this.parentinfo = x.result;
        })
        .catch((x) => {});
    },
    onConfirm(value)
        {
            this.curitem.upgradeActiveRecordDetails[this.curitemProductIndex].specname  = value;
           let spec= this.curitem.upgradeActiveRecordDetails[this.curitemProductIndex].product.specInfo.find(x=>x.specName==value)
            this.curitem.upgradeActiveRecordDetails[this.curitemProductIndex].specid=spec.id;
            this.showPicker = false;
        },
    opengift(item) {
        if(!item.isUse){

        this.curitem = item;
         this.curitem.upgradeActiveRecordDetails.map(x=>{
                x.specid=x.product.specInfo[0].id;
                x.specname=x.product.specInfo[0].specName
            })
        this.nshow = true;
        }

      // localStorage.setItem("drawlottery",JSON.stringify(item));
      // this.$router.push({path:'drawlotterycarddetail'});
    },
    selectp(index){
            this.curitemProductIndex=index;
          this.columns=  this.curitem.upgradeActiveRecordDetails[this.curitemProductIndex].product.specnames;
          console.log(this.columns)
             this.showPicker=true;
        },
    onRefresh() {
      this.loadData("refresh");
    },
    loadData() {
      this.ajax
        .post("/api/services/app/PhoneUpgradeActive/QueryModelListRecord")
        .then((x) => {
          this.list = x.result;
          this.list.forEach((p) => {
            p.payment = 0;
            p.upgradeActiveRecordDetails.map((k) => {
              p.payment += k.payMenet;
            });
            p.upgradeActiveRecordDetails.map(updetail=>{
                    updetail.product.specnames=updetail.product.specInfo.map(sp=>{
                         return sp.specName
                     })
            })
            
          });
        })
        .finally(() => {});
    },
  },
};
</script>
<style lang="scss" scoped>
.drawcards {
  margin: 10px 20px;
  font-size: 14px;
  color: #fff;
  margin-top: -130vw;
}
.drawcard {
  padding: 10px;
  border-radius: 4px;
  background-color: #0000004d;
  margin-bottom: 10px;
  position: relative
}
.draw-content {
  position: relative;
  padding-left: 80px;
  min-height: 60px;
  line-height: 30px;
}
.drawcard-pic {
  position: absolute;
  left: 0;
  width: 60px;
  border-radius: 8px;
}
.drawcard-pic img {
  width: 100%;
  height: 100%;
  border-radius: 8px;
}
.drawcard-mm {
  position: absolute;
  right: 0px;
  top: 0;
  font-size: 12px;
}

.oo {
  margin: 5px;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 1px 1px 3px #c3c3c3;
}

.ooad {
  position: relative;
  padding: 10px 50px 10px 50px;
}

.oo-left {
  position: absolute;
  left: 15px;
  top: 50%;
  transform: translate(0, -50%);
}

.oo-right {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translate(0, -50%);
}

.tit {
  font-size: 14px;
}

.titphone {
  margin-left: 10px;
  font-size: 12px;
  color: #ababab;
}

.oold {
  padding: 10px;
}

.oonj {
  position: relative;
  min-height: 90px;
  padding-left: 90px;
}

.oonj-img {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translate(0, -50%);
  width: 80px;
  height: 80px;
}

.oonj-img img {
  width: 100%;
  height: auto;
  border-radius: 4px;
}

.oonj-info {
}

.oonj-info-tit {
  font-size: 14px;
  margin-bottom: 5px;
  width: calc(100% - 90px);
  word-break: break-all;
}

.oonj-info-tit .price {
  position: absolute;
  right: 0;
  top: 0;
}

.oonj-info-stitc {
  color: #b1b1b1;
  margin-bottom: 5px;
  font-size: 12px;
}

.oonj-info-stitc span:last-child {
  float: right;
}

.oonj-info-stit {
  color: #b1b1b1;
  margin-bottom: 5px;
  font-size: 12px;
}

.oomain {
}

.oomain-info {
  font-size: 13px;
  margin-bottom: 10px;
}

.oomain-info-dd {
  border-bottom: 1px solid #f5f5f5;
  padding: 10px 0;
  position: relative;
}

.ft {
  display: inline-block;
  width: 80px;
}

.ft-main {
  display: inline-block;
  width: calc(100% - 120px);
}

.ft-icon {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translate(0, -50%);
}

.oomain-info-dd input {
  width: calc(100% - 100px);
  border: 0;
}

.oomain-info-dd:last-child {
  border: 0;
}

.oofooter {
  text-align: right;
}

.oofooter .num {
  margin-right: 5px;
}

.oofooter .price {
  color: red;
}
.drawcard-wz{
    text-align: right;
    margin-right: 10px;
}
.nmheader{
    margin-top:3px;
    min-height: 18px;
}
</style>
